/**
 * Staff'sRoom用のスライダーコンテンツ
 *  - SP表示のみスライダーを適用
 *  ※Swiperのライブラリが読み込まれている前提
 */
export default class StaffRoomSlider extends HTMLElement {
  constructor() {
    super();

    const options = {
      spaceBetween: 0,
      slidesPerView: 1,
      loop: true,
      speed: 300,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: 'unico-staffroom-slider .unico-staff-room .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: 'unico-staffroom-slider .unico-staff-room .swiper-button-next',
        prevEl: 'unico-staffroom-slider .unico-staff-room .swiper-button-prev',
      },
    }
    const breakPoint = 768;

    let swiper;
    if ( window.innerWidth <= breakPoint ) {
      swiper = new Swiper('unico-staffroom-slider .unico-staff-room .swiper', options);
    } else {
      swiper = undefined;
    }

    window.addEventListener('resize', () => {
      if ( window.innerWidth <= breakPoint ) {
        if( swiper ) return;
        swiper = new Swiper('unico-staffroom-slider .unico-staff-room .swiper', options);
      } else {
        if( !swiper ) return;
        swiper.destroy();
        swiper = undefined;
      }
    }, false);
  }
}

